var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtpStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "main-svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2791,
    height: 940,
    viewBox: "0 0 2791 940",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-FATEHPUR_YARD_LAYOUT_-_FiNAL"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2791,
    height: 940
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FATEHPUR_YARD_LAYOUT_-_FiNAL",
    "data-name": "FATEHPUR YARD LAYOUT - FiNAL",
    clipPath: "url(#clip-FATEHPUR_YARD_LAYOUT_-_FiNAL)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2791,
    height: 940,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "YardLayout",
    transform: "translate(-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Canvas"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Canvas-Background",
    transform: "translate(4)",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2791,
    height: 940,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 2790,
    height: 939,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Canvas-StationInfo",
    transform: "translate(1216 186)",
    fill: "#fff",
    fontSize: 80,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\tFATEHPUR\n\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "Signal",
    transform: "translate(-337 -184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "POLES",
    transform: "translate(567 586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "POLES11",
    transform: "translate(-532 -768)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1152",
    y2: 35.5,
    transform: "translate(1292.5 929)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES1153",
    x2: 11,
    transform: "translate(1281.5 964.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES10"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1052",
    y1: 36,
    transform: "translate(-0.5 52.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES1053",
    x1: 11,
    transform: "translate(-0.5 52.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES1054",
    x1: 10,
    transform: "translate(32 53)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES1055",
    x1: 11,
    transform: "translate(70 53)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES9",
    transform: "translate(-1287 -768)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES952",
    y2: 35.5,
    transform: "translate(1292.5 929)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES953",
    x2: 11,
    transform: "translate(1281.5 964.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES7",
    transform: "translate(2189 38)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES752",
    y1: 35.5,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES753",
    x1: 11,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES5",
    transform: "translate(1171 -31)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES552",
    y1: 35.5,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES553",
    x1: 11,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES6",
    transform: "translate(1179 38)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES652",
    y1: 35.5,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES653",
    x1: 11,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES8",
    transform: "translate(2150 247)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES852",
    y2: 71.5,
    transform: "translate(39.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES853",
    x2: 11,
    transform: "translate(28.5 71.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES854",
    x2: 11,
    transform: "translate(-2.5 71.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES855",
    x2: 11,
    transform: "translate(-41.5 71.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES857",
    x1: 26,
    transform: "translate(-67.5 71.5)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: "2 3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES4",
    transform: "translate(-488 -907)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES452",
    y2: 35.5,
    transform: "translate(1292.5 929)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES453",
    x2: 11,
    transform: "translate(1281.5 964.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES2",
    transform: "translate(-567 -682)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES252",
    y2: 35.5,
    transform: "translate(1292.5 929)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES253",
    x2: 11,
    transform: "translate(1281.5 964.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES1",
    transform: "translate(-567 -586)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES152",
    y2: 35.5,
    transform: "translate(1292.5 929)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES153",
    x2: 11,
    transform: "translate(1281.5 964.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SG5",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_S5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SG5Aspect01",
    transform: "translate(1253 950)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_S5Aspect01"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG5Label",
    transform: "translate(1237 973)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    "edge-id-selector": "FTP_SG_S5Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t5\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SG7",
    transform: "translate(0 -96)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_S7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SG7Aspect01",
    transform: "translate(1253 950)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_S7Aspect01"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG7Label",
    transform: "translate(1237 973)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    "edge-id-selector": "FTP_SG_S7Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t7\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SG11",
    transform: "translate(35 -182)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_S11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SG11Aspect01",
    transform: "translate(1253 950)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_S11Aspect01"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG11Label",
    transform: "translate(1226 973)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    "edge-id-selector": "FTP_SG_S11Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t11\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SG13",
    transform: "translate(79 -321)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_S13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SG13Aspect01",
    transform: "translate(1253 950)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_S13Aspect01"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG13Label",
    transform: "translate(1226 973)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    "edge-id-selector": "FTP_SG_S13Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t13\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SG6",
    transform: "translate(1738 555)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_S6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SG6Aspect01",
    transform: "translate(10.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_S6Aspect01"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG6Label",
    transform: "translate(45 23)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    "edge-id-selector": "FTP_SG_S6Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t6\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SG4",
    transform: "translate(1746 624)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_S4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SG4Aspect01",
    transform: "translate(10.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_S4Aspect01"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG4Label",
    transform: "translate(45 23)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    "edge-id-selector": "FTP_SG_S4Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t4\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SG1UGE",
    transform: "translate(2717 833)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_1UGE"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SG1UGEAspect01",
    x1: 20,
    y2: 17,
    transform: "translate(-61.5 71.5)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_1UGEAspect01"
  }), /*#__PURE__*/React.createElement("text", {
    id: "SG1UGELabel",
    transform: "translate(-102 113)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    "edge-id-selector": "FTP_SG_1UGELabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t1UGE\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SG3UGE",
    transform: "translate(2717 833)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_3UGE"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SG3UGEAspect01",
    x1: 18,
    y1: 19,
    transform: "translate(-59.5 52.5)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_3UGEAspect01"
  }), /*#__PURE__*/React.createElement("text", {
    id: "SG3UGELabel",
    transform: "translate(-107 48)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    "edge-id-selector": "FTP_SG_3UGELabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t3UGE\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SG5UGE",
    transform: "translate(2717 833)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_5UGE"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SG5UGEAspect01",
    y1: 26,
    transform: "translate(-41.5 45.5)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_5UGEAspect01"
  }), /*#__PURE__*/React.createElement("text", {
    id: "SG5UGELabel",
    transform: "translate(-45 37)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    "edge-id-selector": "FTP_SG_5UGELabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t5UGE\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SGC3",
    transform: "translate(2717 833)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_SC3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGC3Aspect01",
    transform: "translate(8 61)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_SC3Aspect01"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SGC3Label",
    transform: "translate(8 106)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    "edge-id-selector": "FTP_SG_SC3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tC3\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SG3",
    transform: "translate(2717 833)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_S3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SG3Aspect01",
    transform: "translate(-31 57)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_S3Aspect01"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG3Label",
    transform: "translate(-22 110)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    "edge-id-selector": "FTP_SG_S3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t3\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SG2",
    transform: "translate(2756 624)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_S2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SG2Aspect01",
    transform: "translate(11)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_S2Aspect01"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG2Label",
    transform: "translate(20 -7)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    "edge-id-selector": "FTP_SG_S2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t2\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SG19",
    transform: "translate(-720 -182)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_S19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SG19Aspect01",
    transform: "translate(1253 951)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_S19Aspect01"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG19Label",
    transform: "translate(1253 1004)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    "edge-id-selector": "FTP_SG_S19Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t19\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SGC18",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_SC18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGC18Aspect01",
    transform: "translate(577.5 628.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_SC18Aspect01"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SGC18Label",
    transform: "translate(565 621)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    "edge-id-selector": "FTP_SG_SC18Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\tC18\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SG18",
    transform: "translate(567 586)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_S18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SG18Aspect01",
    transform: "translate(41.5 38.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_S18Aspect01"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG18Label",
    transform: "translate(42 31)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    "edge-id-selector": "FTP_SG_S18Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t18\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "SG18UGE",
    transform: "translate(567 586)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_SG_18UGE"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SG18UGEAspect02",
    x2: 26,
    transform: "translate(81 53)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: "2 3",
    "edge-id-selector": "FTP_SG_18UGEAspect02"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SG18UGEAspect01",
    y1: 17,
    x2: 20,
    transform: "translate(81 36)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "FTP_SG_18UGEAspect01"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_18UGELabel",
    "data-name": "18UGELabel",
    transform: "translate(81 29)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t18UGE\n\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TrackCircuit",
    transform: "translate(-337 -184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TC201AT",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_201AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC201ATLine",
    x2: 244,
    transform: "translate(2298.5 675.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_201ATLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC201ATName",
    transform: "translate(-489 -153)",
    "edge-id-selector": "FTP_TC_201ATName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC201ATRectangle",
    width: 54,
    height: 20,
    transform: "translate(2883 817)",
    "edge-id-selector": "FTP_TC_201ATRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC201ATLabel",
    transform: "translate(2910 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_201ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.76,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t201AT\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC2T",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC2TLine",
    x2: 61,
    transform: "translate(2778.5 675.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_2TLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC2TName",
    transform: "translate(-97 -152)",
    "edge-id-selector": "FTP_TC_2TName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC2TRectangle",
    width: 27,
    height: 20,
    transform: "translate(2893 817)",
    "edge-id-selector": "FTP_TC_2TRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC2TLabel",
    transform: "translate(2906 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.438,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t2T\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC3T",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_3T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC3TLine",
    x2: 186,
    transform: "translate(2550.5 831.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_3TLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC3TName",
    "edge-id-selector": "FTP_TC_3TName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC3TRectangle",
    width: 26,
    height: 20,
    transform: "translate(2631 822)",
    "edge-id-selector": "FTP_TC_3TRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC3TLabel",
    transform: "translate(2644 838)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_3TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.438,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t3T\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCC3T",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_C3T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCC3TLine",
    x2: 247,
    transform: "translate(2744.5 831.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_C3TLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCC3TName",
    transform: "translate(-32 4)",
    "edge-id-selector": "FTP_TC_C3TName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCC3TRectangle",
    width: 36,
    height: 20,
    transform: "translate(2882 817)",
    "edge-id-selector": "FTP_TC_C3TRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCC3TLabel",
    transform: "translate(2900 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_C3TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.169,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tC3T\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC4T",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_4T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC4TLine",
    x2: 220,
    transform: "translate(2550.5 675.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_4TLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC4TName",
    transform: "translate(-246 -153)",
    "edge-id-selector": "FTP_TC_4TName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC4TRectangle",
    width: 26,
    height: 20,
    transform: "translate(2894 817)",
    "edge-id-selector": "FTP_TC_4TRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC4TLabel",
    transform: "translate(2907 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_4TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.438,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t4T\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC201BT",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_201BT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC201BTLine",
    x2: 246,
    transform: "translate(2296.5 831.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_201BTLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC201BTName",
    "edge-id-selector": "FTP_TC_201BTName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC201BTRectangle",
    width: 54,
    height: 20,
    transform: "translate(2393 821)",
    "edge-id-selector": "FTP_TC_201BTRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC201BTLabel",
    transform: "translate(2420 837)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_201BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.874,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t201BT\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC202BT",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_202BT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC202BTLine",
    x2: 280,
    transform: "translate(2010.5 675.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_202BTLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC202BTName",
    transform: "translate(-728 -153)",
    "edge-id-selector": "FTP_TC_202BTName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC202BTRectangle",
    width: 54,
    height: 20,
    transform: "translate(2883 817)",
    "edge-id-selector": "FTP_TC_202BTRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC202BTLabel",
    transform: "translate(2910 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_202BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.874,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t202BT\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC202AT",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_202AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC202ATLine",
    x2: 303,
    transform: "translate(1905.5 606.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_202ATLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC202ATName",
    transform: "translate(-767 -222)",
    "edge-id-selector": "FTP_TC_202ATName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC202ATRectangle",
    width: 54,
    height: 20,
    transform: "translate(2883 817)",
    "edge-id-selector": "FTP_TC_202ATRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC202ATLabel",
    transform: "translate(2910 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_202ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.76,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t202AT\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC207AT",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_207AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC207ATLine",
    x2: 238,
    transform: "translate(2050.5 831.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_207ATLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC207ATName",
    transform: "translate(-250)",
    "edge-id-selector": "FTP_TC_207ATName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC207ATRectangle",
    width: 54,
    height: 20,
    transform: "translate(2393 821)",
    "edge-id-selector": "FTP_TC_207ATRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC207ATLabel",
    transform: "translate(2420 837)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_207ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.76,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t207AT\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCC18T",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_C18T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCC18TLine",
    x2: 87,
    transform: "translate(489.5 675.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_C18TLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCC18TName",
    transform: "translate(-2377 -153)",
    "edge-id-selector": "FTP_TC_C18TName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCC18TRectangle",
    width: 44,
    height: 20,
    transform: "translate(2888 817)",
    "edge-id-selector": "FTP_TC_C18TRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCC18TLabel",
    transform: "translate(2910 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_C18TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.457,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tC18T\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC19T",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_19T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC19TLine",
    x2: 64,
    transform: "translate(487.5 745.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_19TLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC19TName",
    transform: "translate(-2389 -82)",
    "edge-id-selector": "FTP_TC_19TName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC19TRectangle",
    width: 36,
    height: 20,
    transform: "translate(2888 817)",
    "edge-id-selector": "FTP_TC_19TRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC19TLabel",
    transform: "translate(2906 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_19TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.726,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t19T\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC7T",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_7T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC7TLine",
    x2: 295,
    transform: "translate(559.5 745.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_7TLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC7TName",
    transform: "translate(-2194 -82)",
    "edge-id-selector": "FTP_TC_7TName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC7TRectangle",
    width: 26,
    height: 20,
    transform: "translate(2888 817)",
    "edge-id-selector": "FTP_TC_7TRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC7TLabel",
    transform: "translate(2901 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_7TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.438,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t7T\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC18T",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_18T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC18TLine",
    x2: 246,
    transform: "translate(584.5 675.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_18TLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC18TName",
    transform: "translate(-2190 -153)",
    "edge-id-selector": "FTP_TC_18TName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC18TRectangle",
    width: 36,
    height: 20,
    transform: "translate(2880 817)",
    "edge-id-selector": "FTP_TC_18TRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC18TLabel",
    transform: "translate(2898 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_18TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.726,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t18T\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC299AT",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_299AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC299ATLine",
    x2: 128,
    transform: "translate(838.5 675.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_299ATLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC299ATName",
    transform: "translate(-1995 -153)",
    "edge-id-selector": "FTP_TC_299ATName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC299ATRectangle",
    width: 54,
    height: 20,
    transform: "translate(2871 817)",
    "edge-id-selector": "FTP_TC_299ATRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC299ATLabel",
    transform: "translate(2898 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_299ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.76,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t299AT\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC299BT",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_299BT"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TC299BTLine",
    d: "M0,0H26.566C36-1.3,73,11,73,11",
    transform: "translate(862.5 745.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_299BTLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC299BTName",
    transform: "translate(-1699.848 -754.524) rotate(14)",
    "edge-id-selector": "FTP_TC_299BTName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC299BTRectangle",
    width: 43,
    height: 20,
    transform: "translate(2876 817)",
    "edge-id-selector": "FTP_TC_299BTRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC299BTLabel",
    transform: "translate(2898 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_299BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.874,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t299BT\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC297BT",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_297BT"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TC297BTLine",
    d: "M0,0A357.412,357.412,0,0,1,36.346,12.8C57.1,21.3,83,34,83,34",
    transform: "translate(941.5 759.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_297BTLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC297BTName",
    transform: "translate(-1395.179 -1075.391) rotate(22)",
    "edge-id-selector": "FTP_TC_297BTName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC297BTRectangle",
    width: 54,
    height: 20,
    transform: "translate(2871 817)",
    "edge-id-selector": "FTP_TC_297BTRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC297BTLabel",
    transform: "translate(2898 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_297BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.874,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t297BT\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC295AT",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_295AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC295ATLine",
    x2: 170,
    transform: "translate(1077.5 927.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_295ATLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC295ATName",
    transform: "translate(-1729 100)",
    "edge-id-selector": "FTP_TC_295ATName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC295ATRectangle",
    width: 54,
    height: 20,
    transform: "translate(2865 817)",
    "edge-id-selector": "FTP_TC_295ATRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC295ATLabel",
    transform: "translate(2892 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_295ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.76,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t295AT\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC296_8BT",
    "data-name": "TC296/8BT",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_296/8BT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC296_8BTLine",
    "data-name": "TC296/8BTLine",
    x2: 169,
    transform: "translate(974.5 675.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_296/8BTLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC296_8BTName",
    "data-name": "TC296/8BTName",
    transform: "translate(-1801 -153)",
    "edge-id-selector": "FTP_TC_296/8BTName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC296_8BTRectangle",
    "data-name": "TC296/8BTRectangle",
    width: 68,
    height: 20,
    transform: "translate(2865 817)",
    "edge-id-selector": "FTP_TC_296/8BTRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC296_8BTLabel",
    "data-name": "TC296/8BTLabel",
    transform: "translate(2899 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_296/8BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -28.916,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t296/8BT\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCUL2T1",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_UL2T1"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCUL2T1Line",
    x2: 189,
    transform: "translate(1598.5 927.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_UL2T1Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCUL2T1Name",
    transform: "translate(-1199 100)",
    "edge-id-selector": "FTP_TC_UL2T1Name"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCUL2T1Rectangle",
    width: 54,
    height: 20,
    transform: "translate(2865 817)",
    "edge-id-selector": "FTP_TC_UL2T1Rectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCUL2T1Label",
    transform: "translate(2892 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_UL2T1Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.079,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tUL2T1\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCUL2T2",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_UL2T2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCUL2T2Line",
    x2: 193,
    transform: "translate(1397.5 927.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_UL2T2Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCUL2T2Name",
    transform: "translate(-1393 100)",
    "edge-id-selector": "FTP_TC_UL2T2Name"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCUL2T2Rectangle",
    width: 54,
    height: 20,
    transform: "translate(2865 817)",
    "edge-id-selector": "FTP_TC_UL2T2Rectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCUL2T2Label",
    transform: "translate(2892 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_UL2T2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.079,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tUL2T2\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCUL2T3",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_UL2T3"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCUL2T3Line",
    x2: 134,
    transform: "translate(1255.5 927.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_UL2T3Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCUL2T3Name",
    transform: "translate(-1569 100)",
    "edge-id-selector": "FTP_TC_UL2T3Name"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCUL2T3Rectangle",
    width: 54,
    height: 20,
    transform: "translate(2865 817)",
    "edge-id-selector": "FTP_TC_UL2T3Rectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCUL2T3Label",
    transform: "translate(2892 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_UL2T3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.079,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tUL2T3\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC205BT",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_205BT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC205BTLine",
    x2: 76,
    transform: "translate(1966.5 831.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_205BTLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC205BTName",
    transform: "translate(-415)",
    "edge-id-selector": "FTP_TC_205BTName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC205BTRectangle",
    width: 54,
    height: 20,
    transform: "translate(2393 821)",
    "edge-id-selector": "FTP_TC_205BTRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC205BTLabel",
    transform: "translate(2420 837)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_205BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.874,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t205BT\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC203T",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_203T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC203TLine",
    x2: 121,
    transform: "translate(1837.5 831.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_203TLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC203TName",
    transform: "translate(-541)",
    "edge-id-selector": "FTP_TC_203TName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC203TRectangle",
    width: 44,
    height: 20,
    transform: "translate(2393 821)",
    "edge-id-selector": "FTP_TC_203TRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC203TLabel",
    transform: "translate(2415 837)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_203TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.014,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t203T\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCUMT1",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_UMT1"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCUMT1Line",
    x2: 224,
    transform: "translate(1605.5 831.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_UMT1Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCUMT1Name",
    transform: "translate(-701)",
    "edge-id-selector": "FTP_TC_UMT1Name"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCUMT1Rectangle",
    width: 52,
    height: 20,
    transform: "translate(2393 821)",
    "edge-id-selector": "FTP_TC_UMT1Rectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCUMT1Label",
    transform: "translate(2419 837)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_UMT1Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.669,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tUMT1\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCUMT2",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_UMT2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCUMT2Line",
    x2: 181,
    transform: "translate(1416.5 831.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_UMT2Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCUMT2Name",
    transform: "translate(-912)",
    "edge-id-selector": "FTP_TC_UMT2Name"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCUMT2Rectangle",
    width: 52,
    height: 20,
    transform: "translate(2393 821)",
    "edge-id-selector": "FTP_TC_UMT2Rectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCUMT2Label",
    transform: "translate(2419 837)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_UMT2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.669,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tUMT2\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCUMT3",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_UMT3"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCUMT3Line",
    x2: 121,
    transform: "translate(1287.5 831.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_UMT3Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCUMT3Name",
    transform: "translate(-1071)",
    "edge-id-selector": "FTP_TC_UMT3Name"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCUMT3Rectangle",
    width: 52,
    height: 20,
    transform: "translate(2393 821)",
    "edge-id-selector": "FTP_TC_UMT3Rectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCUMT3Label",
    transform: "translate(2419 837)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_UMT3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.669,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tUMT3\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC295BT",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_295BT"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TC295BTLine",
    d: "M-126.076-34.26C-96.867-20.139-16.07,0,14.18,0H121",
    transform: "translate(1158.5 831.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_295BTLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC295BTName",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, -1105.948, -411.43)",
    "edge-id-selector": "FTP_TC_295BTName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC295BTRectangle",
    width: 52,
    height: 20,
    transform: "translate(2393 821)",
    "edge-id-selector": "FTP_TC_295BTRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC295BTLabel",
    transform: "translate(2419 837)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_295BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.874,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t295BT\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC204AT",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_204AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC204ATLine",
    x2: 117,
    transform: "translate(1801.5 745.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_204ATLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC204ATName",
    transform: "translate(-570 -86)",
    "edge-id-selector": "FTP_TC_204ATName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC204ATRectangle",
    width: 52,
    height: 20,
    transform: "translate(2393 821)",
    "edge-id-selector": "FTP_TC_204ATRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC204ATLabel",
    transform: "translate(2419 837)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_204ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.76,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t204AT\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCUL1T1",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_UL1T1"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCUL1T1Line",
    x2: 180,
    transform: "translate(1613.5 745.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_UL1T1Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCUL1T1Name",
    transform: "translate(-715 -86)",
    "edge-id-selector": "FTP_TC_UL1T1Name"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCUL1T1Rectangle",
    width: 52,
    height: 20,
    transform: "translate(2393 821)",
    "edge-id-selector": "FTP_TC_UL1T1Rectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCUL1T1Label",
    transform: "translate(2419 837)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_UL1T1Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.079,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tUL1T1\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCUL1T2",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_UL1T2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCUL1T2Line",
    x2: 190,
    transform: "translate(1415.5 745.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_UL1T2Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCUL1T2Name",
    transform: "translate(-908 -86)",
    "edge-id-selector": "FTP_TC_UL1T2Name"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCUL1T2Rectangle",
    width: 52,
    height: 20,
    transform: "translate(2393 821)",
    "edge-id-selector": "FTP_TC_UL1T2Rectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCUL1T2Label",
    transform: "translate(2419 837)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_UL1T2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.079,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tUL1T2\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCUL1T3",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_UL1T3"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCUL1T3Line",
    x2: 89,
    transform: "translate(1318.5 745.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_UL1T3Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCUL1T3Name",
    transform: "translate(-1056 -88)",
    "edge-id-selector": "FTP_TC_UL1T3Name"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCUL1T3Rectangle",
    width: 52,
    height: 20,
    transform: "translate(2393 821)",
    "edge-id-selector": "FTP_TC_UL1T3Rectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCUL1T3Label",
    transform: "translate(2419 837)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_UL1T3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.079,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tUL1T3\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC11T",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_11T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC11TLine",
    x2: 170,
    transform: "translate(1140.5 745.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_11TLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC11TName",
    transform: "translate(-1196 -86)",
    "edge-id-selector": "FTP_TC_11TName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC11TRectangle",
    width: 36,
    height: 20,
    transform: "translate(2404 821)",
    "edge-id-selector": "FTP_TC_11TRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC11TLabel",
    transform: "translate(2422 837)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_11TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.726,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t11T\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC297_8BT",
    "data-name": "TC297/8BT",
    className: "tooltip",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC297_8BTLine",
    "data-name": "TC297/8BTLine",
    x2: 73,
    transform: "translate(1059.5 745.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC297_8BTName",
    "data-name": "TC297/8BTName",
    transform: "translate(-1326 -86)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC297_8BTRectangle",
    "data-name": "TC297/8BTRectangle",
    width: 59,
    height: 20,
    transform: "translate(2393 821)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC297_8BTLabel",
    "data-name": "TC297/8BTLabel",
    transform: "translate(2422 837)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -28.916,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t297/8BT\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC204BT",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_204BT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC204BTLine",
    x2: 101,
    transform: "translate(1901.5 675.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_204BTLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC204BTName",
    transform: "translate(-938 -153)",
    "edge-id-selector": "FTP_TC_204BTName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC204BTRectangle",
    width: 52,
    height: 20,
    transform: "translate(2865 817)",
    "edge-id-selector": "FTP_TC_204BTRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC204BTLabel",
    transform: "translate(2891 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_204BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.874,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t204BT\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCDMT3",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_DMT3"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCDMT3Line",
    x2: 280,
    transform: "translate(1613.5 675.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_DMT3Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCDMT3Name",
    transform: "translate(-1193 -153)",
    "edge-id-selector": "FTP_TC_DMT3Name"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCDMT3Rectangle",
    width: 52,
    height: 20,
    transform: "translate(2865 817)",
    "edge-id-selector": "FTP_TC_DMT3Rectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCDMT3Label",
    transform: "translate(2891 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_DMT3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.676,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tDMT3\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCDMT2",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_DMT2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCDMT2Line",
    x2: 231,
    transform: "translate(1374.5 675.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_DMT2Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCDMT2Name",
    transform: "translate(-1401 -153)",
    "edge-id-selector": "FTP_TC_DMT2Name"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCDMT2Rectangle",
    width: 52,
    height: 20,
    transform: "translate(2865 817)",
    "edge-id-selector": "FTP_TC_DMT2Rectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCDMT2Label",
    transform: "translate(2891 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_DMT2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.676,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tDMT2\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCDMT1",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_DMT1"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCDMT1Line",
    x2: 215,
    transform: "translate(1151.5 675.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_DMT1Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCDMT1Name",
    transform: "translate(-1632 -153)",
    "edge-id-selector": "FTP_TC_DMT1Name"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCDMT1Rectangle",
    width: 52,
    height: 20,
    transform: "translate(2865 817)",
    "edge-id-selector": "FTP_TC_DMT1Rectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCDMT1Label",
    transform: "translate(2891 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_DMT1Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.676,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tDMT1\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC292T",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_292T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC292TLine",
    x2: 198,
    transform: "translate(1134.5 606.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_292TLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC292TName",
    transform: "translate(-1640 -221)",
    "edge-id-selector": "FTP_TC_292TName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC292TRectangle",
    width: 52,
    height: 20,
    transform: "translate(2865 817)",
    "edge-id-selector": "FTP_TC_292TRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC292TLabel",
    transform: "translate(2891 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_292TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.014,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t292T\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCUDLT1",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_UDLT1"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCUDLT1Line",
    x2: 194,
    transform: "translate(1340.5 606.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_UDLT1Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCUDLT1Name",
    transform: "translate(-1456 -221)",
    "edge-id-selector": "FTP_TC_UDLT1Name"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCUDLT1Rectangle",
    width: 58,
    height: 20,
    transform: "translate(2865 817)",
    "edge-id-selector": "FTP_TC_UDLT1Rectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCUDLT1Label",
    transform: "translate(2894 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_UDLT1Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.258,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tUDLT1\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCUDLT2",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_UDLT2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCUDLT2Line",
    x2: 90,
    transform: "translate(1542.5 606.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_UDLT2Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCUDLT2Name",
    transform: "translate(-1306 -221)",
    "edge-id-selector": "FTP_TC_UDLT2Name"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCUDLT2Rectangle",
    width: 58,
    height: 20,
    transform: "translate(2865 817)",
    "edge-id-selector": "FTP_TC_UDLT2Rectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCUDLT2Label",
    transform: "translate(2894 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_UDLT2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.258,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tUDLT2\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TCUDLT3",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_UDLT3"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCUDLT3Line",
    x2: 257,
    transform: "translate(1640.5 606.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_UDLT3Line"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TCUDLT3Name",
    transform: "translate(-1203 -221)",
    "edge-id-selector": "FTP_TC_UDLT3Name"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TCUDLT3Rectangle",
    width: 58,
    height: 20,
    transform: "translate(2865 817)",
    "edge-id-selector": "FTP_TC_UDLT3Rectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCUDLT3Label",
    transform: "translate(2894 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_UDLT3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.258,
    y: 0
  }, "\n\t\t\t\t\t\t\t\tUDLT3\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC294T",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_294T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC294TLine",
    x2: 160,
    transform: "translate(966.5 606.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_294TLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC294TName",
    transform: "translate(-1851 -221)",
    "edge-id-selector": "FTP_TC_294TName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC294TRectangle",
    width: 52,
    height: 20,
    transform: "translate(2865 817)",
    "edge-id-selector": "FTP_TC_294TRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC294TLabel",
    transform: "translate(2891 833)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_294TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.014,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t294T\n\t\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TC207BT",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_TC_207BT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC207BTLine",
    x2: 119,
    transform: "translate(2080.5 924.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "FTP_TC_207BTLine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TC207BTName",
    transform: "translate(-280 94)",
    "edge-id-selector": "FTP_TC_207BTName"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TC207BTRectangle",
    width: 54,
    height: 20,
    transform: "translate(2393 821)",
    "edge-id-selector": "FTP_TC_207BTRectangle"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC207BTLabel",
    transform: "translate(2420 837)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_TC_207BTLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.874,
    y: 0
  }, "\n\t\t\t\t\t\t\t\t207BT\n\t\t\t\t\t\t\t"))))), /*#__PURE__*/React.createElement("g", {
    id: "PointMachine",
    transform: "translate(-337 -184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM299B",
    transform: "translate(-1263 68)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_299B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM299BIcon",
    transform: "translate(2129 655)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_299BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM299BLabel",
    transform: "translate(2106 649)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_299BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t299B\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM299A",
    transform: "translate(-1178 3)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_299A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM299AIcon",
    transform: "translate(2129 655)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_299AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM299ALabel",
    transform: "translate(2106 649)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_299ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t299A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM298B",
    transform: "translate(-1045 133)",
    className: "tooltip",
    title: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM298BIcon",
    transform: "translate(2030 554)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM298BLabel",
    transform: "translate(2007 584)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t298B\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM298A",
    transform: "translate(-1089 64)",
    className: "tooltip",
    title: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM298AIcon",
    transform: "translate(2129 655)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM298ALabel",
    transform: "translate(2129 649)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t298A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM297B",
    transform: "translate(-1071 231)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_297B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM297BIcon",
    transform: "translate(2030 554)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_297BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM297BLabel",
    transform: "translate(2007 584)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_297BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t297B\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM297A",
    transform: "translate(-986 206)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_297A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM297AIcon",
    transform: "translate(2030 554)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_297AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM297ALabel",
    transform: "translate(2030 584)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_297ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t297A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM296B",
    transform: "translate(-1098 -3)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_296B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM296BIcon",
    transform: "translate(2129 655)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_296BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM296BLabel",
    transform: "translate(2106 649)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_296BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t296B\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM296A",
    transform: "translate(-1034 -69)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_296A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM296AIcon",
    transform: "translate(2129 655)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_296AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM296ALabel",
    transform: "translate(2106 649)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_296ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t296A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM295B",
    transform: "translate(-1004 262)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_295B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM295BIcon",
    transform: "translate(2030 554)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_295BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM295BLabel",
    transform: "translate(2030 584)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_295BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t295B\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM295A",
    transform: "translate(-913 313)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_295A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM295AIcon",
    transform: "translate(2030 590)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_295AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM295ALabel",
    transform: "translate(2030 584)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_295ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t295A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM292B",
    transform: "translate(-984 -74)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_292B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM292BIcon",
    transform: "translate(2129 655)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_292BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM292BLabel",
    transform: "translate(2129 649)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_292BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t292B\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM292A",
    transform: "translate(-890 -149)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_292A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM292AIcon",
    transform: "translate(2129 655)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_292AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM292ALabel",
    transform: "translate(2129 649)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_292ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t292A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM207B",
    transform: "translate(38 243)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_207B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM207BIcon",
    transform: "translate(2129 655)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_207BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM207BLabel",
    transform: "translate(2129 649)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_207BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t207B\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM207A",
    transform: "translate(-254 157)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_207A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM207AIcon",
    transform: "translate(2313 689)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_207AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM207ALabel",
    transform: "translate(2313 719)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_207ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t207A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM205B",
    transform: "translate(-63 215)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_205B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM205BIcon",
    transform: "translate(2053 590)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_205BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM205BLabel",
    transform: "translate(2030 584)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_205BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t205B\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM205A",
    transform: "translate(-139 203)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_205A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM205AIcon",
    transform: "translate(2030 554)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_205AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM205ALabel",
    transform: "translate(2030 584)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_205ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t205A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM204B",
    transform: "translate(-63 134)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_204B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM204BIcon",
    transform: "translate(2030 554)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_204BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM204BLabel",
    transform: "translate(2030 584)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_204BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t204B\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM204A",
    transform: "translate(-164 131)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_204A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM204AIcon",
    transform: "translate(2053 590)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_204AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM204ALabel",
    transform: "translate(2030 584)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_204ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t204A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM203B",
    transform: "translate(-371 157)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_203B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM203BIcon",
    transform: "translate(2313 689)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_203BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM203BLabel",
    transform: "translate(2313 719)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_203BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t203B\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM203A",
    transform: "translate(-498 248)",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_203A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM203AIcon",
    transform: "translate(2313 689)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_203AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM203ALabel",
    transform: "translate(2313 719)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_203ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t203A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM202B",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_202B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM202BIcon",
    transform: "translate(2129 655)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_202BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM202BLabel",
    transform: "translate(2129 649)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_202BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t202B\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM202A",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_202A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM202AIcon",
    transform: "translate(2030 590)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_202AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM202ALabel",
    transform: "translate(2030 584)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_202ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t202A\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM201B",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_201B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM201BIcon",
    transform: "translate(2486 807)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_201BIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM201BLabel",
    transform: "translate(2486 801)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_201BLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n\t\t\t\t\t\t\t201B\n\t\t\t\t\t\t"))), /*#__PURE__*/React.createElement("g", {
    id: "PM201A",
    className: "tooltip",
    title: "",
    "edge-id": "FTP_PM_201A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM201AIcon",
    transform: "translate(2313 689)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "FTP_PM_201AIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM201ALabel",
    transform: "translate(2331 719)",
    fill: "#6c7091",
    fontSize: 15,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "FTP_PM_201ALabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.611,
    y: 0
  }, "\n\t\t\t\t\t\t\t201A\n\t\t\t\t\t\t")))), /*#__PURE__*/React.createElement("g", {
    id: "TongueRail",
    transform: "translate(-337 -184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TR012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TR012104",
    d: "M0,0S45.255-.512,61.034,23.763s40.661,77.074,63.116,96.494,60.49,20.382,60.49,20.382",
    transform: "translate(2312.86 683.86)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TR012103",
    y1: 16,
    transform: "translate(2411.157 753.843) rotate(45)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "TR011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TR01166",
    d: "M0,0S24.184-3.027,36.928,9.11,65.846,40.166,76.156,50.225,111,60,111,60",
    transform: "translate(2029.5 611.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TR01165",
    y1: 16,
    transform: "translate(2092.157 635.843) rotate(45)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "TR010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TR010110",
    d: "M0,0H29.9C54.2,1.079,67.559,75.7,90.391,75.662h29.833",
    transform: "translate(2058.5 839.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TR010109",
    y1: 12,
    x2: 15,
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 2110.914, 872.317)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "TR009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TR009111",
    d: "M0,62H20.571C38.25,61.913,47.918.865,70.293,0H90",
    transform: "translate(866.5 679.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TR009110",
    x2: 13,
    y2: 8,
    transform: "translate(903.5 706.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "TR008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TR008113",
    d: "M0,9l21.814,6.745C37.016,22.774,67.581-.437,84.253,0h7.574",
    transform: "translate(960.5 751.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TR008112",
    x2: 6,
    y2: 14,
    transform: "translate(1013.5 753.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "TR007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TR00702",
    d: "M-1.493,2.26H21.39C37.9,1.933,34.793,59.3,56.532,60H69.7",
    transform: "translate(982.5 679.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TR00701",
    y1: 5,
    x2: 14,
    transform: "translate(1013.5 712.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "TR006"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TR00602",
    d: "M.336,58.179H22.6C46.3,62.129,46.66,1.44,68.565,1.8H89.035",
    transform: "translate(1889.5 680.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TR00601",
    x2: 13,
    y2: 10,
    transform: "translate(1927.5 710.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "TR005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TR00502",
    d: "M0,0H21.882c21.188-3.843,33.4,67.978,71.1,72H115",
    transform: "translate(1889.5 751.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TR00501",
    y1: 10,
    x2: 11,
    transform: "translate(1937.5 783.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "TR004",
    d: "M0,84H31.164C67.792,85.04,67.792.292,112.321,0h30.165",
    transform: "translate(1814.5 837.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "TR003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TR00302",
    d: "M0,0,21.423,8.735C49.046,18.679,53.19,115.361,81.642,117H100",
    transform: "translate(1032.5 804.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TR00301",
    y1: 6,
    x2: 14,
    transform: "translate(1075.5 861.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "TR002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TR00202",
    d: "M0,67H23.846C50.979,68.515,73.208-1.443,97.727,0H116",
    transform: "translate(1143.5 532.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TR00201",
    x2: 12,
    y2: 9,
    transform: "translate(1200.5 558.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "TR001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TR00102",
    d: "M0,58H20.9C43.823,58.645,46.033-.469,64.265,0H85",
    transform: "translate(1027.5 611.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TR00101",
    x2: 13,
    y2: 4,
    transform: "translate(1065.5 636.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Separator",
    transform: "translate(-337 -184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SEP012"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SEP01261",
    y2: 16,
    transform: "translate(2774.5 667.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP01262",
    y2: 16,
    transform: "translate(2546.5 667.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP01263",
    y2: 16,
    transform: "translate(2294.5 667.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP01264",
    y2: 16,
    transform: "translate(2006.5 667.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP01266",
    y2: 16,
    transform: "translate(1897.5 667.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP01267",
    y2: 16,
    transform: "translate(1609.5 667.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP01268",
    y2: 16,
    transform: "translate(1370.5 667.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP01269",
    y2: 16,
    transform: "translate(1147.5 667.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP01270",
    y2: 16,
    transform: "translate(970.5 667.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP01271",
    y2: 16,
    transform: "translate(834.5 667.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP01272",
    y2: 16,
    transform: "translate(580.5 667.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "SEP01211"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SEP0121173",
    y2: 16,
    transform: "translate(485.5 667.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0121174",
    x1: 10.5,
    transform: "translate(484 683.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SEP011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SEP01125"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SEP0112575",
    y2: 16,
    transform: "translate(555.5 737.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "SEP0112512",
    transform: "translate(-3 70)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SEP011251273",
    y2: 16,
    transform: "translate(485.5 667.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP011251274",
    x1: 10.5,
    transform: "translate(484 683.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112576",
    y2: 16,
    transform: "translate(858.5 737.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112577",
    y2: 16,
    transform: "translate(941.236 750.982) rotate(20)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112578",
    x1: 7.736,
    y2: 14.518,
    transform: "translate(1023.764 788.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112579",
    y2: 16,
    transform: "translate(1283.5 823.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112580",
    y2: 16,
    transform: "translate(1412.5 823.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112581",
    y2: 16,
    transform: "translate(1601.5 823.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112582",
    y2: 16,
    transform: "translate(1833.5 823.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112583",
    y2: 16,
    transform: "translate(1962.5 823.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112584",
    y2: 16,
    transform: "translate(2046.5 823.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112585",
    y2: 16,
    transform: "translate(2292.5 823.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112586",
    y2: 16,
    transform: "translate(2546.5 823.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112587",
    y2: 16,
    transform: "translate(2740.5 823.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "SEP01115"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SEP0111588",
    y2: 16,
    transform: "translate(2843.5 667.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0111589",
    x1: 10,
    transform: "translate(2835 667.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "SEP01122"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SEP0112290",
    y2: 16,
    transform: "translate(1136.5 737.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112291",
    y2: 16,
    transform: "translate(1314.5 737.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112292",
    y2: 16,
    transform: "translate(1411.5 737.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112293",
    y2: 16,
    transform: "translate(1609.5 737.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112294",
    y2: 16,
    transform: "translate(1797.5 737.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "SEP01123"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SEP0112395",
    y2: 16,
    transform: "translate(1901.5 598.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112396",
    y2: 16,
    transform: "translate(1636.5 598.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112397",
    y2: 16,
    transform: "translate(1538.5 598.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112398",
    y2: 16,
    transform: "translate(1336.5 597.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP0112399",
    y2: 16,
    transform: "translate(1130.5 597.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SEP010"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SEP010100",
    y2: 16,
    transform: "translate(1393.5 919.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP010101",
    y2: 16,
    transform: "translate(1251.5 919.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP010102",
    y2: 16,
    transform: "translate(1594.5 919.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "SEP009"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SEP009106",
    y2: 16,
    transform: "translate(2076.5 916.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP009107",
    x1: 12,
    transform: "translate(2075 932.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "SEP008"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SEP008-02",
    y2: 16,
    transform: "translate(2203.5 916.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP008-01",
    x1: 11,
    transform: "translate(2194 916.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("line", {
    id: "SEP007",
    y2: 16,
    transform: "translate(1056.5 737.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP006",
    x2: 15,
    transform: "translate(1037.5 745.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "SEP005",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("line", {
    id: "SEP005-02",
    y2: 16,
    transform: "translate(1073.5 919.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP005-01",
    x1: 10,
    transform: "translate(1072 935.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "SEP004",
    d: "M0,0H41.883C61.857.435,70,8,70,8",
    transform: "translate(1795.5 927.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP003",
    y2: 16,
    transform: "translate(1791.5 919.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP002",
    x2: 174,
    y2: 1,
    transform: "translate(1236.5 523.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "SEP001",
    y2: 20,
    transform: "translate(1410.5 513.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtpStation);
export default __webpack_public_path__ + "static/media/FTP_Station.b52ce9bbd09509f46fed2fd010b6e03a.svg";
export { ForwardRef as ReactComponent };